import { forwardRef } from 'react';
import { TableRow as MuiTableRow } from '@mui/material';
import { useInterstateTheme } from '../../InterstateThemeProvider';

/** Compact elements that show attributes or action  */
import { jsx as _jsx } from "react/jsx-runtime";
export const TableRow = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    id,
    className,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const style = {};
  return /*#__PURE__*/_jsx(MuiTableRow, {
    ref: ref,
    id: id,
    "data-testid": rest['data-testid'],
    className: className,
    children: children
  });
});
TableRow.displayName = 'TableRow';